var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$safe(_vm.row,'Locked'))?_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Kilitli")]):_c('b-badge',{attrs:{"variant":"dark"}},[_vm._v("İşlem Yapılabilir")])}
var staticRenderFns = []

export { render, staticRenderFns }